import { useEffect, useRef } from "react";
import styles from "./popup.module.scss";

export function Popup({ onClose }) {
  const modalRef = useRef(null);

	useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

		document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [onClose])

	return (
		<div className={styles.popup} ref={modalRef}>
			<div className={styles.popup__scroll}>
				<button className={styles.popup__close} onClick={onClose}>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" >
						<line x1="4" y1="4" x2="20" y2="20" />
						<line x1="20" y1="4" x2="4" y2="20" />
					</svg>
				</button>
				<div className={styles.popup__content}>
					<img src="/images/renewStat/popup.png" alt=""/>
				</div>
			</div>
		</div>
	)
}